import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowFieldError } from '../modals';

function onClick() {
    const transportType = $('input[name="caseBean.transportType"]:checked').val();
    const otherTransportType = $('input[name="caseBean.otherTransportType"]').val();
    if (transportType === undefined || (transportType === 'other' && otherTransportType === '')) {
        new DKFDS.Toast(document.getElementById('createVehicleMissingTransportType')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('createVehicleModal')).show();
    }
}

function createVehicle() {
    const $title = $('input[name="vehicleTitle"]');
    if ($title.val().trim() === '') {
        fdsShowFieldError($title, 'Du skal angive en titel');
    }
    else {
        $title.closest('form').append('<input type="hidden" name="saveVehicle" value="1">').submit();
    }
}

$(() => {
    const $modal = $('#createVehicleModal');
    $('#btnCreateVehicleModal').on('click', onClick);
    $('#createVehicleModalOK').on('click', createVehicle)
    $modal.get(0).addEventListener('fds.modal.hidden', () => fdsReset($modal));
});
